module.exports = __webpack_public_path__ + "img/circle-down-right.62a3e7ba.svg";